<template>
    <div>
        <div>
            <img src="../../assets/MK体育 - MK(中国)一站式服务官方网站/news/1.png" style="width: 100%;height: auto" alt="">
        </div>

        <div v-for="item in tempNews">
            <div class="index-div-content product-info-div news-div">
                <el-row   type="flex" class="product-info-div-flex news-index-content">
                    <el-col :xs="24" :sm="10">
                        <div class="product-image-zoom">
                            <div class='magnify'>
                                <div class='large'></div>
                                <img  :src="item.imgUrl" class='small' alt="">
                            </div>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="14" class="news-content">
                        <router-link :to='"/company/news/"+item.id'> <h3 class="font-24 product-header">{{item.title}}</h3></router-link>
                        <p class="product-content" v-html="item.content.length>80?(item.content.substr(0,80)+'...'):item.content">
                        </p>
                        <p>
                            {{item.time}}
                        </p>
                        <router-link :to='"/company/news/"+item.id'>
                            <el-button type="primary" class="button button-info">
                                详情
                            </el-button>
                        </router-link>
                    </el-col>

                </el-row>
            </div>
        </div>

        <div class="news-page">
            <el-pagination
                    :page-size="pageSize"
                    :pager-count="5"
                    :current-page="currentPage"
                    @current-change="changeCurrentPage"
                    prev-text="上一页"
                    next-text="下一页"
                    :hide-on-single-page="total<=5"
                    layout="prev, pager, next"
                    :total="total">
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import CompanyNews from "../../json/CompanyNews";

    export default {
        name: "index",
        data() {
            return {
                companyNews: CompanyNews,
                currentPage: 1,
                pageSize: 5,
                total: 0,
                tempNews: []
            }
        },
        mounted() {
            this.getAll()
        },
        methods: {
            getAll() {
                this.total = this.companyNews.news.length
                this.changeCurrentPage(this.currentPage)
            },
            changeCurrentPage(pageNum) {
                this.tempNews = []
                this.tempNews = this.companyNews.news.slice((pageNum - 1) * this.pageSize, pageNum * this.pageSize)
                console.log(this.tempNews)
            }
        }

    }
</script>
<style lang="scss">
    .news-page {
        margin-top: 30px;
        text-align: center;

        .number {
            background: #FFFFFF;
            width: 40px;
            height: 40px;
            line-height: 40px;
            margin-left: 15px;

            &.active {
                background: #005DAB;
            }
        }

        .btn-prev, .btn-next {
            width: 90px;
            height: 40px;
            line-height: 40px;
            box-shadow: none;
            margin-left: 15px;

            span {
                line-height: 40px;
            }
        }
    }
</style>
<style lang="scss" scoped>
    .product-content {
        line-height: 30px;
    }
    .news-content{
        min-height: 224px;
    }



</style>